import { render, staticRenderFns } from "./TokenDetails.vue?vue&type=template&id=5aa29090"
import script from "./TokenDetails.vue?vue&type=script&lang=js"
export * from "./TokenDetails.vue?vue&type=script&lang=js"
import style0 from "./TokenDetails.vue?vue&type=style&index=0&id=5aa29090&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports